export default {
    methods: {
        filename(str, ext){
            str = str.replace(/[\W_]/g, "-");
            str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
            str = str.replace(/\p{Diacritic}/gu, "");
            return str+"."+ext;
        }
    }
}